<template>
  <v-autocomplete
    hide-details
    dense
    outlined
    deletable-chips
    small-chips
    clearable
    :items="items"
    v-model="selectedEvents"
    multiple
    return-object
    :item-text="
      (item) =>
        (item.eventType === eventTypes.arrival ? arrChar : depChar) +
        ' ' +
        item.flight.number
    "
  >
    <template v-slot:item="{ item }">
      <v-list-item-icon>
        <event-icon v-model="item.eventType" />
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title v-html="item.flight.number"></v-list-item-title>
        <v-list-item-subtitle
          >{{ item.flight.actualDepApIata }} -
          {{ item.flight.actualArrApIata }}</v-list-item-subtitle
        >
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
  import EventIcon from '@/components/EventIcon'
  import { eventTypes } from '../config/eventTypes'

  export default {
    name: 'FlightEventsSelect',
    props: {
      value: {
        type: Array,
        required: true
      },
      items: {
        type: Array,
        required: true
      }
    },
    data: () => ({
      arrChar: '↘',
      depChar: '↗'
    }),
    components: {
      EventIcon
    },
    computed: {
      eventTypes() {
        return eventTypes
      },
      selectedEvents: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        }
      },
      allSelected() {
        return this.selectedEvents.length === this.items.length
      },
      someSelected() {
        return this.selectedEvents.length > 0 && !this.allSelected
      },
      icon() {
        if (this.allSelected) return 'mdi-close-box'
        if (this.someSelected) return 'mdi-minus-box'
        return 'mdi-checkbox-blank-outline'
      }
    },
    methods: {
      toggle() {
        this.$nextTick(() => {
          if (this.allSelected) {
            this.selectedEvents = []
          } else {
            this.selectedEvents = this.items.slice()
          }
        })
      }
    }
  }
</script>
